import { css } from 'emotion';

import { DeviceInfo } from '@ezugi/utils/src';

const mobileRules = css`
    @media (orientation: landscape) {
      top: 0;
    }

    @media (max-height: 375px) {
      position: relative;
      top: -80px;
    }
`;

export const multiplierWinClassName = css`
    backdrop-filter: blur(8px) !important;
    background: rgba(0, 0, 0, 0.6) !important;
    position: relative;
    top: -5% !important;

    ${DeviceInfo.isHandheld ? mobileRules : ''}

    & [data-name='result-display'] {
      position: absolute;
      bottom: 120px;
      padding: 6px;

      background: rgba(0, 0, 0, 0.8);
      border-radius: 4px;
      z-index: 1;
    }
`;
